<div class="ai-summary-container" *ngIf="_syllabusData">
  <div class="header-banner">
    <div class="header-content">
      <mat-icon (click)="goToBack()" class="back">arrow_back</mat-icon>
      <h4>
        Your AI-Generated
        <span>{{ _syllabusData.course_title || "--" }}</span> Course is
        Ready!
      </h4>
    </div>
    <p class="sub-text">
      A structured learning plan created for you with clear objectives, key
      topics & resources for smooth facilitation.
    </p>
  </div>
  <div class="course-box">
    <div class="course-header">
      <div class="left">
        <h2 class="course-title">
          {{ _syllabusData.course_title }}
          <img src="assets/images/edit.svg" *ngIf="status !== courseStatus.Published"
            class="ms-1"
            (click)="
              openEditDialogBox(
                _CourseDataType.Course_Title,
                _syllabusData.course_title
              )
            "
          >
        </h2>
        <div class="code">
          <strong>Course Code : {{ _syllabusData.course_code || "--" }}</strong>
          <img src="assets/images/edit.svg" *ngIf="status !== courseStatus.Published"
            class="ms-2"
            (click)="
              openEditDialogBox(_CourseDataType.Code, _syllabusData.course_code)
            "
          >
        </div>
        <div class="meta-tags">
          <span class="tag">
            <i class="bi bi-journal-bookmark-fill"></i> Units
            {{ _syllabusData.total_units_count || "--" }}
            <!-- <i for now we are not using this edit option for course duration....as per the requirement
              class="bi bi-pencil ms-1"
              (click)="
                openEditDialogBox(
                  _CourseDataType.Course_Unit_Count,
                  _syllabusData.total_units_count
                )
              "
            ></i> -->
          </span>
          <span class="tag">
            <i class="bi bi-clock"></i>
            {{ _syllabusData.course_duration || "--" }} hours
            <!-- <i for now we are not using this edit option for course duration....as per the requirement
              class="bi bi-pencil ms-1"
              (click)="
                openEditDialogBox(
                  _CourseDataType.Course_duration,
                  _syllabusData.course_duration
                )
              "
            ></i> -->
          </span>
        </div>
      </div>
       <div class="right">
		<ng-container *ngIf ="!courseId">
        <button class="btn-outline" (click)="postAllCourseData(courseStatus.Draft)"
		  [disabled]="isLoadingDraft || isLoadingPublish">
			<ng-container *ngIf="isLoadingDraft; else draftContent">
      <span class="spinner-border spinner-border-sm"></span> Saving...
			</ng-container>
			 <ng-template #draftContent>
          <i class="bi bi-save"></i> Save as draft
		      </ng-template>
        </button>

        <button class="btn-primary" (click)="postAllCourseData(courseStatus.Published)"
		  [disabled]="isLoadingDraft || isLoadingPublish">
			    <ng-container *ngIf="isLoadingPublish; else publishContent">
					<span class="spinner-border spinner-border-sm"></span> Processing...
            </ng-container>
			    <ng-template #publishContent>
				<img src="assets/images/publish.png" alt="publish" class="unit-icon">Publish
		      </ng-template>
        </button>
	</ng-container>

	 <ng-container *ngIf="courseId && status === courseStatus.Draft">
			<button class="btn-outline" (click)="openDeleteCourseDialogBox(courseId)">Delete Draft</button>
            <button class="btn-primary" (click)="patchPublishedCourseByStatus()"
		  [disabled]="isPublish">
			    <ng-container *ngIf="isPublish; else publishContent">
					<span class="spinner-border spinner-border-sm"></span> Processing...
            </ng-container>
			    <ng-template #publishContent>
				<img src="assets/images/publish.png" alt="publish" class="unit-icon">Publish</ng-template>
        </button> 
	</ng-container>

	<ng-container *ngIf="courseId && status === courseStatus.Published">
           <button class="btn-primary" (click)="openUnpublishDialogBox()">
			<img src="assets/images/publish.png" alt="publish" class="unit-icon">Unpublish</button>
	</ng-container>

 </div>
    </div>

    <div class="main-container gap-2">
      <div class="course-section">
		<div class="justify-content-between d-flex">
        <h3 class="section-title">Course Structure</h3>
		<button class="btn-add d-flex align-items-center gap-1" (click)="addUnit()"  matTooltip="Add a new unit"
		*ngIf="status !== courseStatus.Published">
		<mat-icon>add</mat-icon>Unit</button>
    </div>
		<div cdkDropList (cdkDropListDropped)="onUnitDrop($event)" 
		class="course-block-wrapper">
		<div 
          class="course-block mb-3"
          *ngFor="let unit of _syllabusData.units; let i = index" cdkDrag
		  [cdkDragDisabled]="status === courseStatus.Published">
          <div class="block-header">
			      <div cdkDragHandle class="drag-handle">
            <img
              src="assets/images/ai-toggle.svg"
              alt="Unit Icon"
              class="unit-icon mb-4"
            /></div>
            <h4 class="unit-title">
              Unit {{ unit.order || "--" }}: 
			  <span [innerHtml]="unit.unit_title || '--'"></span>
              <img src="assets/images/edit.svg" class="ms-3" (click)="editUnitById(unit.unit_id)"
			  *ngIf="status !== courseStatus.Published">
            <h6 class="hour mt-2">
				 <i class="bi bi-clock"></i> Total Duration : {{unit.unit_hours}} hours </h6>
            </h4>
            <div class="block-actions">
		<button  (click)="addTopic(unit)" class="icon-button-end" matTooltip="Add a new topic"
		*ngIf="status !== courseStatus.Published">
      <mat-icon>add</mat-icon>
       </button>
              <button  class="icon-btn delete-btn" aria-label="Delete" *ngIf="status !== courseStatus.Published"
                (click)="openDeleteDialogBox(_CourseDataType.Unit, unit.unit_id)">
                <i class="bi bi-trash-fill"></i>
              </button>
            </div>
          </div>
          <mat-accordion multi class="block-content outer-accordion" cdkDropList
		  	[cdkDropListData] = "unit.topics"
		    (cdkDropListDropped)="onTopicDrop($event , unit)">
            <mat-expansion-panel class="topic" *ngFor="let topic of unit.topics" cdkDrag
			 [cdkDragDisabled]="status === courseStatus.Published">
				<mat-expansion-panel-header>
					 <div class="d-flex justify-content-between align-items-start w-100">
					<div class="d-flex">
						<div cdkDragHandle class="drag-handle m-0">
				<img src="assets/images/drag.png" class="me-3 topic-icon" alt="drag-icon">
				</div>
                  <span [innerHtml]="topic.topic_title || '--'" class="title-wrapper"></span>
				  	<img src="assets/images/edit.svg" class="ms-3"
                 *ngIf="status !== courseStatus.Published"
                  (click)="editTopicById(unit.unit_id, topic.topic_id)">
              </div>
                <i class="bi bi-trash-fill delete-btn me-3" *ngIf="status !== courseStatus.Published"
                (click)="openDeleteDialogBox(_CourseDataType.Topic, unit.unit_id, topic.topic_id)"></i>
		</div>
		</mat-expansion-panel-header>
		 <div class="px-x">
			    <p class="topic-description text-muted mb-3"> {{topic.description}}</p>
			<div class="subtopic-card" *ngFor="let sub of topic.subtopics">
				<div class="subtopic-header">
					<span class="dot"></span>
                 <h6><span  [innerHtml]=" sub.subtopic_title || '--' "></span></h6>
				</div>
				 <p class="description">{{sub.description || 'N/A'}}</p>
				   <ng-container *ngIf="sub.reference_links?.length">
						<div class="reference">
				  <label>References Links: </label>
				  <ul>
					<li *ngFor="let link of sub.reference_links">
						<a [href]="link" target="_blank"> {{link}} </a>
					</li>
				  </ul>
				  </div>
				  </ng-container>
			        </div>
			</div>
            </mat-expansion-panel>
          </mat-accordion>
</div>
</div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img
                src="assets/images/courseObject.png"
                alt="Course Icon"
                class="unit-icon"
              />
              <h4>Course Objective</h4>
             <img src="assets/images/edit.svg" class="ms-3" *ngIf="status !== courseStatus.Published"
                (click)="openEditDialogBox( _CourseDataType.Objectives,_syllabusData.course_objectives)">
            </div>
            <div class="block-actions">
              <button
                class="delete-btn" *ngIf="status !== courseStatus.Published"
                (click)="openDeleteDialogBox(_CourseDataType.Objectives)"
                aria-label="Delete All Objectives"
              >
                <i class="bi bi-trash-fill"></i>
              </button>
            </div>
          </div>

          <ul class="objective-list">
            <li *ngFor="let objective of _syllabusData?.course_objectives">
              {{ objective || "--" }}
            </li>
          </ul>
        </div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img
                src="assets/images/courseOutcome.png"
                alt="Course Icon"
                class="unit-icon"
              />
              <h4>Course Outcome</h4>
              <img src="assets/images/edit.svg" class="ms-3" *ngIf="status !== courseStatus.Published"
                (click)="
                  openEditDialogBox(_CourseDataType.Outcome,_syllabusData.course_outcomes)">
            </div>
            <div class="block-actions">
              <button
                class="delete-btn" *ngIf="status !== courseStatus.Published"
                (click)="openDeleteDialogBox(_CourseDataType.Outcome)"
                aria-label="Delete All Outcomes"
              >
                <i class="bi bi-trash-fill"></i>
              </button>
            </div>
          </div>

          <ul class="objective-list">
            <li *ngFor="let course_name of _syllabusData.course_outcomes">
              {{ course_name || "--" }}
            </li>
          </ul>
        </div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img
                src="assets/images/webLink.png"
                alt="Course Icon"
                class="unit-icon"
              />
              <h4>Resources and Reference Links</h4>
            </div>
            <div class="block-actions">
              <button
                class="delete-btn" *ngIf="status !== courseStatus.Published"
                (click)="openDeleteDialogBox(_CourseDataType.Resources)">
                <i class="bi bi-trash-fill"></i>
              </button>
            </div>
          </div>
          <h6>
            <i class="bi bi-journal-bookmark-fill"></i> Textbooks
          </h6>
          <ul
            class="objective-list"
            *ngIf="_syllabusData?.textbooks?.length; else noTextbooks"
          >
            <li *ngFor="let book of _syllabusData.textbooks; let i = index">
              <strong>{{ book.title || "--" }} , </strong> 
              {{ book.author || "--" }} , 
              <small
                >{{ book.publisher || "--" }}, {{ book.year || "--" }}</small
              >
			   <img src="assets/images/edit.svg" class="ms-3" *ngIf="status !== courseStatus.Published"
	         (click)="openTextBookDialogBox(book,i)"> 
            </li>
          </ul>
          <ng-template #noTextbooks>
            <p class="empty-note">No textbooks added yet.</p>
          </ng-template>
          <h6>
            <i class="bi bi-globe"></i> Weblinks
            <img src="assets/images/edit.svg" *ngIf="status !== courseStatus.Published"
              (click)="
                openEditDialogBox(
                  _CourseDataType.Weblinks,
                  _syllabusData.web_references_links
                )
              "
            >
          </h6>
          <ul
            class="objective-list"
            *ngIf="_syllabusData?.web_references_links?.length; else noLinks"
          >
            <li *ngFor="let web_link of _syllabusData.web_references_links">
              <a [href]="web_link" target="_blank" class="web_link">{{
                web_link || "--"
              }}</a>
            </li>
          </ul>

          <ng-template #noLinks>
            <p class="empty-note">No web links added yet.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>